@if (model) {
    @if (isLoading) {
        <div class="fancy-loader"></div>
    } @else {
        <findings-linkable
            #linkable
            displayValueProp="name"
            [linked]="linked"
            [unlinked]="unlinked"
            [hideActions]="true"
            [orderByValueProperty]="true"
            (linkedChange)="linkedChanged($event)"
            [disabled]="disabled"
        >
        </findings-linkable>
    }
}
